export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";